import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';

import CloseIcon from "@mui/icons-material/Close";
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { mainListItems, secondaryListItems , adminListItems } from './listItems';
import Profile from './profile'
import { useAlert } from '../content/Alert/Alert';
import "./CSS/styles.css";
import { useNavigate, Outlet } from 'react-router-dom';
import defaultTheme from './Theme';
import Footer from './dashboard/About'
import MuiDrawer from '@mui/material/Drawer';
import AlwaysOnBoolingIcon from './BookingIcon/AlwaysOnBookingIcon';
import { FormatAlignJustify } from '@mui/icons-material';
const drawerWidth = 240;
const drawerHeight = 'fit-content';
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open, isMobile }) => ({
    '& .MuiDrawer-paper': {
      position: isMobile ? 'relative' : 'fixed',
      top: isMobile ? 'auto' : 0, // For mobile, no need to anchor to the top
      left: isMobile ? 'auto' : 0, // Non-mobile spans width
      right: isMobile ? '0' : 0, // Full width on non-mobile
      whiteSpace: 'nowrap',
      width: isMobile ? drawerWidth : 'auto',
      height: isMobile ? 'auto' : drawerHeight, // For top drawer on non-mobile
      transition: theme.transitions.create(isMobile ? 'width' : 'height', {
        easing: theme.transitions.easing.sharp,
        duration: open
          ? theme.transitions.duration.enteringScreen
          : theme.transitions.duration.leavingScreen,
      }),
      boxSizing: 'border-box',
      ...(isMobile && !open && {
        overflowX: 'hidden',
        display: 'none', // Hide for mobile when closed
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
      ...(!isMobile && !open && {
        overflowY: 'hidden', // Vertical scroll for non-mobile when closed
        display: 'none',     // Hide when closed
        height: 0,           // Collapse height when closed
      }),
    },
  })
);

export default function Layout(){
    const [open, setOpen] = React.useState(false);
    const navigate = useNavigate();
  const [isMobile, setIsMobile] = React.useState(false);
 
  const {showAlert ,authToken} = useAlert();

  const isAuthenticated = authToken;
  const [isLargeScreen, setIsLargeScreen] = React.useState(false);

    const toggleDrawer = () => {
      setOpen(!open);
    };

    
  const checkDeviceWidth = () => {
    // You can adjust the width breakpoint as needed
    if (window.innerWidth >= 768) {
      setOpen(true);
      
      setIsMobile(false); 
      setIsLargeScreen(true);
      } else {
      setOpen(false); 
      setIsMobile(window.innerWidth <= 768); 
      setIsLargeScreen()
      // Open the drawer on tablets and laptops
      // Keep the drawer closed on mobile devices
    }
  };

  React.useEffect(() => {
    // Set initial drawer state based on device width
    checkDeviceWidth();

    // Add resize event listener to handle screen resizing
    window.addEventListener('resize', checkDeviceWidth);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', checkDeviceWidth);
    };
  }, []);

  const handleuMenClick = () => {
    setOpen(false);
    document.body.scrollTop = 0; // for Safari
    document.documentElement.scrollTop = 0; // for modern browsers

    // Close drawer on item click
  };
  


    return(
        
    <ThemeProvider theme={defaultTheme}>
    <Box sx={{ display: 'flex' }}>
      
      <AppBar position="absolute" open={open}   sx={{
    backgroundImage: `linear-gradient(to right, #F4C300 60%, #FFD700 80%, black 100%)`,
  }}
  > 
  
        <Toolbar
          sx={{
            pr: '24px', // keep right padding when drawer closed
          }}
        >
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer}
            sx={{
              marginRight: '36px',
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          
          <Typography
            component="h1"
            variant="h1"
            noWrap
            sx={{ flexGrow: 1,fontSize:'larger' }}

          >
            SVR Taxi & Travels 
          </Typography>
          <IconButton color="inherit">
            <Badge badgeContent={4} color="secondary">
              <NotificationsIcon />
            </Badge>
          </IconButton>
          <Profile />
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open} isMobile={!isMobile}>
  
    
        < >
             <CloseIcon style={{ color: 'black', cursor: 'pointer',display:'flex',justifyContent:'center',width:'30%',height:'30px',marginTop:'10px' }} onClick={handleuMenClick} />
             </> 
    
        <Divider />
        <List component="nav" >

       
          {
            !isAuthenticated && (mainListItems(handleuMenClick))
          }
            {
            isAuthenticated && (adminListItems(handleuMenClick))
          }
          <Divider sx={{ my: 1 }} />
          {secondaryListItems}
        </List>
      </Drawer>
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
         // backgroundImage: `linear-gradient(#B2BEB5 100%)`,
         backkgroundColor:'#B2BEB5',
          backgroundSize: 'cover', // Optional: ensures the image covers the entire AppBar
          backgroundPosition: 'center', 
          
          
          zIndex: 10,
        }}
      >
        <Toolbar />
           <AlwaysOnBoolingIcon/>
           <Outlet />
           
        <Footer/>
        </Box>
        
        </Box>
        </ThemeProvider>
    );
};